<form class="flex flex-col items-stretch gap-4 p-4" [formGroup]="cutoutForm" cslEnterLikeTab>
  <img
    *ngIf="schema?.imageS3Key || schema?.fragmentImageS3Key"
    [src]="imageUrl"
    i18n-alt
    alt="Изображение выреза"
    (click)="openImageViewer(imageUrl)"
    class="cursor-pointer w-auto max-h-44 self-center block outline outline-offset-4 outline-1 outline-slate-400 rounded-md" />

  <mat-form-field appearance="outline" class="w-full dense-input no-subscript">
    <mat-label i18n>Тип</mat-label>
    <mat-select formControlName="type">
      <mat-option [value]="thisCutoutTypeEnum.Rectangle" i18n>Прямоугольник</mat-option>
      <mat-option [value]="thisCutoutTypeEnum.RoundedRectangle" i18n>Прямоугольник со скруглёнными углами</mat-option>
      <mat-option [value]="thisCutoutTypeEnum.Ellipse" i18n>Окружность</mat-option>
      <mat-option disabled [value]="thisCutoutTypeEnum.Fragment" i18n>Фрагмент</mat-option>
    </mat-select>
  </mat-form-field>
  <div class="flex flex-row items-center gap-3">
    <mat-form-field class="w-full dense-input no-subscript" appearance="outline">
      <mat-label>x (мм)</mat-label>
      <input
        type="number"
        formControlName="x"
        matInput
        [matTooltipDisabled]="cutoutForm.get('x').valid"
        [matTooltip]="getError(cutoutForm.get('x').errors)" />
    </mat-form-field>

    <mat-form-field class="w-full dense-input no-subscript" appearance="outline">
      <mat-label>y (мм)</mat-label>
      <input
        type="number"
        formControlName="y"
        matInput
        [matTooltipDisabled]="cutoutForm.get('y').valid"
        [matTooltip]="getError(cutoutForm.get('y').errors)" />
    </mat-form-field>

    <mat-form-field class="w-full dense-input no-subscript" appearance="outline">
      <mat-label i18n>Радиус сопряжения (мм)</mat-label>
      <input
        type="number"
        formControlName="radius"
        matInput
        [matTooltipDisabled]="cutoutForm.get('radius').valid"
        [matTooltip]="getError(cutoutForm.get('radius').errors)" />
    </mat-form-field>
  </div>

  <div class="flex flex-row items-center gap-3">
    <mat-form-field class="w-full dense-input no-subscript" appearance="outline">
      <mat-label i18n>Длина (мм)</mat-label>
      <input
        type="number"
        formControlName="height"
        matInput
        [matTooltipDisabled]="cutoutForm.get('height').valid"
        [matTooltip]="getError(cutoutForm.get('height').errors)" />
    </mat-form-field>

    <mat-form-field class="w-full dense-input no-subscript" appearance="outline">
      <mat-label i18n>Ширина (мм)</mat-label>
      <input
        type="number"
        formControlName="width"
        matInput
        [matTooltipDisabled]="cutoutForm.get('width').valid"
        [matTooltip]="getError(cutoutForm.get('width').errors)" />
    </mat-form-field>
  </div>

  <div>
    <div class="font-medium text-sm mb-1" id="cutoutRotateDeg" i18n>Поворот</div>
    <div class="flex gap-2">
      <button
        mat-stroked-button
        i18n-matTooltip
        matTooltip="Против часовой стрелки"
        (click)="rotateCCW()"
        [disabled]="cutoutForm.get('rotateDeg').disabled">
        <mat-icon>rotate_90_degrees_ccw</mat-icon>
      </button>
      <button
        mat-stroked-button
        i18n-matTooltip
        matTooltip="По часовой стрелке"
        (click)="rotateCW()"
        [disabled]="cutoutForm.get('rotateDeg').disabled">
        <mat-icon class="-scale-x-1">rotate_90_degrees_ccw</mat-icon>
      </button>
    </div>
  </div>

  <div class="flex flex-col gap-3">
    <div>
      <div class="font-medium text-sm mb-1" i18n>База</div>
      <csl-base-point-select
        [disablePoints]="['c']"
        [value]="cutoutPoint2Position(cutoutForm.get('angle').value)"
        (valueChange)="setAngle($event)"></csl-base-point-select>
    </div>

    <div>
      <div class="font-medium text-sm mb-1" i18n>Точка привязки выреза</div>
      <csl-base-point-select
        *ngIf="cutoutForm.get('type').value !== thisCutoutTypeEnum.Fragment; else fragmentBasePoint"
        [showAxis]="false"
        [value]="cutoutPoint2Position(cutoutForm.get('basePoint').value)"
        (valueChange)="setBase($event)"
        [disabled]="
          cutoutForm.get('type').value === thisCutoutTypeEnum.Ellipse ||
          cutoutForm.get('type').value === thisCutoutTypeEnum.Fragment
        ">
      </csl-base-point-select>
      <ng-template #fragmentBasePoint><div i18n>Из фрагмента</div></ng-template>
    </div>
  </div>

  <div *ngIf="showSlotTable" class="flex flex-col items-start gap-3">
    <div i18n class="mat-title m-0">Пазы</div>
    <div class="flex flex-row flex-wrap items-center gap-3 pl-3">
      <ng-container *ngFor="let slot of schema.slots">
        <div class="flex flex-row justify-center items-center gap-1">
          <span class="font-light text-xl">{{ slot.designation }}</span>
          <csl-groove-info class="mt-1" [data]="{ position: 'top', groove: slot, matIconClassName: 's-20' }">
          </csl-groove-info>
        </div>
      </ng-container>
    </div>
  </div>
</form>
